import { createContext, useContext } from "react";

import { IStepperContext } from "./types";

export const StepperContext = createContext<IStepperContext | null>(null);

export const useStepper = () => {
  const context = useContext(StepperContext);

  if (!context) {
    throw new Error("You can only use this context inside a Stepper component.");
  }

  return context;
};